import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white py-2 mt-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex mx-auto px-5 justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#1F2A37] mb-2 md:mb-0 text-center w-max text-sm" }, " Copyright 2023 HelloReeve.com ")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, _hoisted_3))
}